hrd.components.form.AbstractSelectLikeComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.AbstractSelectLikeComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	reEnhanceEditField: function(field, id) {
		let cacheProviderResult = field.data('cache-provider-result');
		cacheProviderResult = (cacheProviderResult === undefined) ? true : cacheProviderResult;
		if (!cacheProviderResult) {
			this.enhanceEditFieldInner(field, id);
		}
	},
	reloadEditField: function(field, id) {
		this.enhanceEditFieldInner(field, id);
	},
	enhanceEditField: function(field, id, klass) {
		this._super(field, id, klass);
		this.enhanceEditFieldInner(field, id);
	},
	disableField: function(field, disable) {
		if(!$('body.chroma-flow').exists() || !field.is('[data-appearance="minimal"]')) {
			field.attr('disabled', disable);
			return;
		}

		const name = field.attr('data-name');
		field
			.closest('.hrd-form')
			.find(`.select-minimal-field[data-id="${name}"]`)
			.attr('disabled', disable);
	},
	initalizeComponentWithUndefined: function(field) {
		let id = this.getFieldId();
		var selectionList = [];

		// if it was 'empty-list' and 'cache-provider-result' it should be reloaded,
		// but should be evaluated only if the combo is empty, in order to avoid to re-invoke provider when not really needed
		if (field.isEmpty()) {
			var emptyList = !!field.data('empty-list');
			var cacheProviderResult = field.data('cache-provider-result');
			cacheProviderResult = (cacheProviderResult === undefined) ? true : cacheProviderResult;
			if (!cacheProviderResult && emptyList) {
				this.enhanceEditFieldInner(field, id);
			}
		}

		field.find('option').each((i, option) => {
			if ($(option).data('initiallySelected') === true) {
				selectionList.push($(option).attr('value'));
			}
		});
		if (selectionList.length > 0) {
			field.selectOptions(selectionList);
			if(field.usingChromaFlow()) {
				field.trigger('field-has-changed.minimal');
			}
		}
	},
	getProvider: function(field) {
		let provider = field.data('provider');
		if (provider) {
			return provider;
		} else {
			let sFnProvider = field.data('fnProvider');
			let fnProvider;
			if (sFnProvider) {
				let name = this.getFieldName();
				if (sFnProvider === true) {
					sFnProvider = $.functionCase(`${name}-fn-provider`);
				}
				if (this.settings.reference && typeof this.settings.reference[sFnProvider] === 'function') {
					fnProvider = this.settings.reference[sFnProvider].call(this.settings.reference, field);
				} else {
					if (this.settings.reference) {
						console.log(`Please, add "${sFnProvider}: function(field) {}," function as fnProvider for "${this.settings.reference._FULL_}. Remember, it must return a 'function'"`);
					}
					fnProvider = field.triggerHandler($.dashedCase(sFnProvider));
				}
			}
			return (fnProvider) ? fnProvider.bind(this.settings.reference) : () => [];
		}
	},
	getLabelProvider: function(field) {
		var labelProperty = field.data('labelProperty');
		// search for a function in the "container/reference" object
		if (this.settings.reference && typeof this.settings.reference[labelProperty] === 'function') {
			//@deprecated because can lead to overlapping cross combos
			return this.settings.reference[labelProperty].bind(this.settings.reference);
		} else {
			var useFn = field.data('labelPropertyFn');
			if (useFn == true) {
				let name = this.getFieldName();
				var fn = $.functionCase(`${name}LabelProperty`);
				if (this.settings.reference && typeof this.settings.reference[fn] === 'function') {
					return this.settings.reference[fn].bind(this.settings.reference);
				} else {
					console.log(`Please, add "${fn}" function as "labelPropertyFunction" for "${this.settings.reference._FULL_}"`);
					return labelProperty;
				}
			} else {
				return labelProperty;
			}
		}
	},
	getExtraArgs: function(field, forceToObject) {
		forceToObject = !!forceToObject;
		let extraArgs = field.data('providerExtraArgs');
		if (extraArgs) {
			//TODO: manage query string of hybrid form: k=v&prop&k=v...
			if (extraArgs.indexOf('=') != -1) {
				return $.String.deparam(extraArgs);
			} else {
				// it is not a query string. it could be an ampersand separated list of properties. as of now only one parameter
				let obj = {}
				let inputData = this.getFormInstanceSetting('inputData');
				if (inputData != undefined) {
					obj[extraArgs] = inputData[extraArgs];
				}
				return obj;
			}
		} else {
			var extraArgsFn = field.data('providerExtraArgsFn');
			if (extraArgsFn) {
				var fn = $.evaluate(extraArgsFn, this.settings.reference);
				if (typeof fn === 'function') {
					var obj = forceToObject ? this.formInstanceToObject() : (this.getFormInstanceSetting('inputData') || this.formInstanceToObject());
					return fn.call(this.settings.reference, field, obj, this.getFormInstance());
				} else {
					console.log(`Please, add "${extraArgsFn}" function as "providerExtraArgsFn" for "${this.settings.reference._FULL_}"`);
				}
			} else {
				return {};
			}
		}
	},
	getOnChangeFn: function(field) {
		let sOnChange = field.data('on-change');
		if (sOnChange) {
			return eval(sOnChange);
		} else {
			return $.noop;
		}
	},
	wrapForGenericSelectAddon: function(field) {
		if (!field.usingChromaFlow()) return;

		if ((field.attr('data-type') === 'select' && field.attr('data-appearance') === 'minimal') || (field.attr('data-type') === 'select1' && field.attr('data-appearance') === 'minimal')) {
			field = field
				.closest('.field-composite')
				.find('.select-minimal-field');
		}

		const $addon = field.closest('.field-composite').find('[data-variants~="addon"]');

		if ($addon.exists() && !$addon.closest('.addon-container').exists()) {
			$addon
				.add($addon.siblings(this.wrappableSelectors))
				.wrapAll('<div class="addon-container field-container"></div>');
		}

		const $allElements = $addon.closest('.field-composite').find('*');
		const $fieldAndAddon = $allElements
			.filter((index, element) => $(element).is(field) || $(element).is($addon));

		$fieldAndAddon
			.each((index, element) => {
				const isFirst = index === 0;
				const isLast = index === $fieldAndAddon.length - 1;

				$(element).removeClass('addon-before addon-after radius-none');

				if(isFirst) {
					$(element).addClass('addon-before');
				} else if(isLast) {
					$(element).addClass('addon-after');
				} else {
					$(element).addClass('radius-none');
				}
			});
	},
});